import React, { useState } from 'react';
import { RoundedButton } from '../../../../../elements';
import { vaultStore } from '../../store/VaultStore';
import {
  ModalWrapper,
  ModalContent,
  ModalBody,
  ModalFooter,
  Title,
  Description,
  Message,
} from './ArchiveVaultModal.styled';

const ArchiveVaultModal = ({ isOpen, onClose, onSubmit, currentName, description, fileId, created_by, files_stored }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.stopPropagation();
    
    setIsSubmitting(true);
    const success = await vaultStore.archiveDocumentFolder({
      folderId: fileId,
      newName: currentName,
      description: description,
      created_by,
      files_stored: files_stored,
    });
    setIsSubmitting(false);
    
    if (success) {
      onSubmit();
    }
  };

  const handleClose = (e) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <ModalWrapper onClick={(e) => e.stopPropagation()}>
      <ModalContent data-testid="archive-modal" role="dialog" onClick={(e) => e.stopPropagation()}>
        <ModalBody>
          <Title>Archive Vault</Title>
          <Message>Are you sure you want to archive <strong>{currentName}</strong>?</Message>
          <Description>You can restore it later from your archive if needed.</Description>
        </ModalBody>
        <ModalFooter>
          <RoundedButton 
            data-testid="close-button"
            kind="default" 
            outline 
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Keep vault
          </RoundedButton>
          <RoundedButton 
            data-testid="archive-button"
            kind="blue" 
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Archiving...' : 'Archive vault'}
          </RoundedButton>
        </ModalFooter>
      </ModalContent>
    </ModalWrapper>
  );
};

export default ArchiveVaultModal; 